import { fabric } from 'fabric';
import { ANNOTATION_TYPE } from '@/shared/ui';
import { convertBeatTypeNumberToText } from '@/shared/ui/components/FabricJS/Helper';

export type BeatSampleMarkOptions = {
  canvasChart: fabric.Canvas;
  config: any;
  displayedChannelsArr: number[];
  pixelSamples: any;
  startSample: number;
  endSample: number;
  markers: { beatMarkers: number[]; currentHesBeatStatus: number[] };
};

// eslint-disable-next-line import/no-mutable-exports
let BeatSampleMark: any;

(function () {
  BeatSampleMark = function ({
    canvasChart,
    config,
    displayedChannelsArr,
    pixelSamples,
    startSample,
    endSample,
    markers,
  }: BeatSampleMarkOptions) {
    this.type = ANNOTATION_TYPE.BEAT_SAMPLE_MARK;
    this.canvasChart = canvasChart;
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
    this.pixelSamples = pixelSamples;
    this.startSample = startSample;
    this.endSample = endSample;
    this.markers = markers;
    this.polylines = [];
    this.lineWidthExport = 1.3; // *: For export
  };

  BeatSampleMark.prototype.draw = function () {
    const { sampleLength, samplingRate } = this.config;

    if (this.endSample < 0) {
      this.endSample = 0;
    }

    if (this.endSample >= sampleLength) {
      this.endSample = sampleLength - 1;
    }

    if (this.startSample < 0) {
      this.startSample = 0;
    }

    if (this.startSample >= sampleLength) {
      this.startSample = sampleLength - 1;
    }
    //* Vẽ màu ecg xung quanh beat S,V 1 khoảng +-250ms
    const sampleMarkLength = Math.round(samplingRate / 4);
    const { beatMarkers, currentHesBeatStatus } = this.markers;
    const beatMarkersLength = beatMarkers.length;
    const lineSegments: { start: number; stop: number; color: string; center: number }[] = [];
    for (let i = 0; i < beatMarkersLength; i += 1) {
      const sample = beatMarkers[i];
      if (this.startSample <= sample && sample <= this.endSample) {
        const type = convertBeatTypeNumberToText(currentHesBeatStatus[i]);
        if (type === 'S' || type === 'V') {
          const previousSample = beatMarkers[i - 1];
          const nextSample = beatMarkers[i + 1];
          let start = sample - sampleMarkLength;
          let stop = sample + sampleMarkLength;
          //* Giảm độ dài đoạn vẽ màu của beat nếu beat nằm trước hoặc sau nó overlap
          //* Nếu beat nằm trước hoặc sau cùng type S hoặc V với beat hiện tại thì nối lại
          if (previousSample) {
            const previousSampleType = convertBeatTypeNumberToText(currentHesBeatStatus[i - 1]);
            if (previousSampleType === type) {
              start = sample - sampleMarkLength;
            } else if (sample - previousSample < sampleMarkLength * 2) {
              const middlePoint = Math.round(Math.abs(sample - previousSample) / 2);
              start = sample - middlePoint;
            }
          }
          if (nextSample) {
            const nextSampleType = convertBeatTypeNumberToText(currentHesBeatStatus[i + 1]);
            if (nextSampleType === type) {
              //  current line stop = next line start;
              stop = nextSample - sampleMarkLength;
            } else if (nextSample - sample < sampleMarkLength * 2) {
              const middlePoint = Math.round(Math.abs(nextSample - sample) / 2);
              stop = sample + middlePoint;
            }
          }
          lineSegments.push({
            start,
            stop,
            color: type === 'S' ? '#E51C22' : '#EB6D17',
            center: sample,
          });
        }
      }
    }

    this.displayedChannelsArr.forEach((element: number, index: number) => {
      lineSegments.forEach((line) => {
        const points = [];
        for (let j = line.start; j < line.stop; j += 1) {
          if (j < sampleLength) {
            // out of range
            points.push(
              new fabric.Point(
                (this.pixelSamples[index][j]?.x ?? 0) -
                  (this.pixelSamples[index][this.startSample]?.x ?? 0),
                this.pixelSamples[index][j]?.y,
              ),
            );
          }
        }
        const pl = new fabric.Polyline(points, {
          stroke: line.color,
          fill: 'transparent',
          strokeWidth: this.lineWidthExport,
          strokeLineJoin: 'round',
          strokeLineCap: 'round',
        });
        this.canvasChart.add(pl);
        this.polylines.push(pl);
      });
    });
  };

  BeatSampleMark.prototype.delete = function () {
    this.polylines.forEach((element: fabric.Polyline) => {
      this.canvasChart.remove(element);
    });
    this.polylines = [];
  };
})();

export { BeatSampleMark };
export default { BeatSampleMark };
